import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: theme.palette.grey[100]
  }
});

const Section = ({children, classes}) => {
  return (
    <div className={ classNames( "Container-Section", classes.root )}>
      { children }
    </div>
  )
}

Section.propTypes = {
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(Section);
